<template>
  <!-- <div class="q-pa-sm text-body1 text-primary text-weight-regular">
    Chukul Early Performance
  </div>
  <q-table
    color="primary"
    :rows="earlyChukulPerformanceData"
    :columns="columns"
    hide-bottom
  ></q-table> -->

  <div
    class="q-pa-sm text-subtitle1 text-weight-medium"
    :class="this.$q.dark.mode === true ? '' : ' text-primary'"
  >
    Chukul Performance Report
  </div>
  <q-table
    flat
    bordered
    color="primary"
    :rows="chukulPerformanceData"
    :columns="columns"
    hide-bottom
    dense
    separator="cell"
    :class="
      $q.dark.mode
        ? 'table-sticky-header-column-dark'
        : 'table-sticky-header-column'
    "
  >
    <template v-slot:header="props">
      <q-tr :props="props">
        <q-th v-for="col in props.cols" :key="col.name" :props="props">
          <div class="text-center">
            {{ col.label }}
          </div>
        </q-th>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
import { ref } from "vue";
import useData from "src/use/data";

export default {
  name: "StatusPage",
  props: {
    searchStock: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { chukulPerformance, earlyChukulPerformance } = useData();

    const chukulPerformanceData = ref([]);
    const earlyChukulPerformanceData = ref([]);

    const columns = [
      {
        name: "avg_profit_in_each_trade",
        label: "Avg profit In each trade",
        field: (row) => parseFloat(row.avg_profit_in_each_trade),
        sortable: true,
        align: "center",
      },
      {
        name: "cummulative_profit",
        label: "Cummulative Profit",
        field: (row) => parseFloat(row.cummulative_profit),
        sortable: true,
        align: "center",
      },
      {
        name: "total_trade",
        label: "Total trade",
        field: (row) => parseFloat(row.total_trade),
        sortable: true,
        align: "center",
      },
      {
        name: "sucess_trade",
        label: "Success trade",
        field: (row) => parseFloat(row.sucess_trade),
        sortable: true,
        align: "center",
      },
      {
        name: "success_rate",
        label: "Success rate",
        field: (row) => parseFloat(row.success_rate),
        sortable: true,
        align: "center",
      },
      {
        name: "days_between_each_trade",
        label: "Days between each trade",
        field: (row) => parseFloat(row.days_between_each_trade),
        sortable: true,
        align: "center",
      },
    ];

    chukulPerformance().then((res) => {
      chukulPerformanceData.value = res.data.filter((item) => {
        return item.symbol === props.searchStock;
      });
    });
    earlyChukulPerformance().then((res) => {
      earlyChukulPerformanceData.value = res.data.filter((item) => {
        return item.symbol === props.searchStock;
      });
    });

    return {
      chukulPerformanceData,
      earlyChukulPerformanceData,
      // signals,
      columns,
    };
  },
};
</script>
